import { useMediaQuery } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { COLOR_DESCRIPTION, DEVICES } from '../../const';

const Container = styled.div`
  background-color: #fff;
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    padding: 60px 0;
    text-align: center;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
    padding: 100px 0;
    text-align: left;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightHeading = styled.div`
  font-weight: 700;
`;

const RightTitle = styled.div`
  font-weight: 700;
  margin-top: 1rem;
  line-height: 1.5;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2.2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.5rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 14px;
  }

  @media ${DEVICES.tablet} {
    font-size: 14px;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

export default function AboutFifthBanner() {

  const overTablet = useMediaQuery(DEVICES.tablet);
  const descriptionTemplate = () => {
    if (overTablet) {
      return <div>
        캥거루짐은 약속합니다. <br />
        아이들이 몸의 기본적인 움직임을 제대로 익히고 느끼는 것. <br />
        이를 바탕으로 아이들의 평생 운동의 시작이 되는 것.
      </div>
    } else {
      return <div>
        캥거루짐은 약속합니다. <br />
        아이들이 몸의 기본적인 움직임을 제대로 익히고 <br />
        느끼는 것. 이를 바탕으로 아이들의 평생 운동의 <br />
        시작이 되는 것. <br />
      </div>
    }
  };

  return (
    <Container>
      <Inner>
        <Left>
          <LeftImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/about/fifth.jpg" />
        </Left>
        <Right>
          <RightHeading>
            아이들이 집중 할 수 있도록
          </RightHeading>
          <RightTitle>
            수업 인원을 정원으로 맞춰 진행하고 있습니다.
          </RightTitle>
          <RightDescription>
            {descriptionTemplate()}
          </RightDescription>
        </Right>
      </Inner>
    </Container>
  )
}
